export const environment = {
  production: false,
  apiUrl: 'https://api-hml.paraisodocerrado.com.br/api'
};
